import { Pressable, Text, View } from 'react-native'
import { Slot, useRouter, useSegments } from 'expo-router'
import { useTranslation } from 'react-i18next'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { Stack, TabScreenContent } from '@/components/layout'
import CustomerServiceButton from '@/components/CustomerServiceButton'
import NotificationButton from '@/components/NotificationButton'
import ScreenHeader from '@/components/ScreenHeader'

type C2cMode = 'buy' | 'sell'

const screenOptions = { header: () => <Header /> }

export default function C2CLayout() {
  const router = useRouter()
  const { t } = useTranslation()
  const mode = useSegments().at(-1) as C2cMode

  return (
    <>
      <Stack.Screen options={screenOptions} />

      <TabScreenContent>
        <View className={'flex-1'}>
          <View className={'h-11 flex-row border-b border-border-10 bg-background-primary'}>
            {(['buy', 'sell'] as const).map((item) => {
              const selected = mode === item
              return (
                <Pressable
                  accessibilityRole={'tab'}
                  accessibilityState={{ selected }}
                  className={'h-full flex-1 items-center justify-center'}
                  key={item}
                  onPress={() => router.replace(`/c2c/${item}`)}
                >
                  <Text className={selected ? 'text-sm font-medium text-text-primary' : 'text-sm font-medium text-text-tertiary'}>
                    {t(`nav.c2cTab.${item}`)}
                  </Text>
                  {selected && <View className={'absolute bottom-[-1px] h-0.5 w-12 rounded-t bg-primary'} />}
                </Pressable>
              )
            })}
          </View>
          <View className={'flex-1'}>
            <Slot />
          </View>
        </View>
      </TabScreenContent>
    </>
  )
}

function Header() {
  const { t } = useTranslation()
  const { top } = useSafeAreaInsets()

  return (
    <View className={'bg-background-primary'} style={{ paddingTop: top }}>
      <ScreenHeader
        leftElement={<CustomerServiceButton />}
        centerElement={<Text className={'text-base font-semibold text-text-primary'}>{t('nav.c2c')}</Text>}
        rightElement={<NotificationButton />}
      />
    </View>
  )
}
